/* assets/gproperty-report-preview.js — GPROPERTY-EVIDENCE-PREVIEW-16
   Local evidence and opaque provenance only. No score, recommendation,
   lead propagation, backend mutation or formal conclusion. */
(function (window, document) {
  'use strict';

  var ROOT = '[data-gproperty-report-preview]';
  var VERSION = 'gproperty-evidence-preview-16';

  var ASSET_LABELS = {
    'residential-estate': '住宅／屋苑',
    'commercial-office': '商業／寫字樓',
    'industrial-warehouse': '工業／倉儲',
    'land-site': '土地／地盤',
    'village-rural': '村屋／鄉村空間',
    'public-institutional': '公共／機構設施',
    'mixed-other': '混合用途／其他',
  };

  var STAGE_LABELS = {
    exploring: '初步了解',
    'due-diligence': '資料核查',
    planning: '方案規劃',
    procurement: '採購／招標準備',
    'active-project': '項目進行中',
  };

  var FILE_LABELS = {
    photos: '照片',
    plans: '圖則',
    'title-documents': '權屬文件',
    'public-links': '公開資料連結',
  };

  function all(root, selector) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function setText(root, selector, value) {
    var node = root.querySelector(selector);
    if (node) node.textContent = value;
  }

  function setHidden(root, selector, hidden) {
    var node = root.querySelector(selector);
    if (node) node.hidden = hidden;
  }

  function create(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function mark(root, key, ready, text) {
    var card = root.querySelector('[data-report-evidence-card="' + key + '"]');
    var badge = root.querySelector('[data-report-evidence-status="' + key + '"]');
    if (card) card.setAttribute('data-ready', ready ? 'true' : 'false');
    if (badge) badge.textContent = ready ? '已有' : key === 'files' ? '可補充' : '缺少';
    setText(root, '[data-report-evidence-value="' + key + '"]', text);
    return ready ? 1 : 0;
  }

  function referenceCandidates(gate, draft) {
    var candidates = [];
    var direct = gate.opaque(draft && draft.result_id);

    if (direct) {
      candidates.push({
        lane: 'direct',
        result_id: direct,
        updated_at: gate.clean(draft.updated_at),
      });
    }

    var refs =
      draft && draft.fit_references && typeof draft.fit_references === 'object'
        ? draft.fit_references
        : {};

    ['family_fit', 'owner_fit', 'school_preview'].forEach(function (lane) {
      var value = refs[lane] && typeof refs[lane] === 'object' ? refs[lane] : null;
      var resultId = gate.opaque(value && value.result_id);
      if (!resultId) return;

      candidates.push({
        lane: lane,
        result_id: resultId,
        updated_at: gate.clean(value.updated_at),
      });
    });

    return candidates.sort(function (a, b) {
      return String(b.updated_at || '').localeCompare(String(a.updated_at || ''));
    });
  }

  function realResultReference(gate, draft, query) {
    var candidates = referenceCandidates(gate, draft);
    var requested = gate.opaque(query.get('result_id'));

    if (requested) {
      var matched = candidates.find(function (item) {
        return item.result_id === requested;
      });
      if (matched) return matched;
    }

    return (
      candidates[0] || {
        lane: '',
        result_id: '',
        updated_at: '',
      }
    );
  }

  function safeLink(gate, base, draft, result, intent) {
    var url;

    try {
      url = new URL(base, window.location.origin);
    } catch (_) {
      return base;
    }

    [
      'address',
      'address_zh',
      'address_en',
      'estate',
      'district',
      'budget',
      'school_net',
      'child',
      'phone',
      'email',
      'lead_id',
      'score',
      'service_lane',
    ].forEach(function (key) {
      url.searchParams.delete(key);
    });

    url.searchParams.set(
      'source',
      intent === 'manual-verification' ? 'gproperty' : 'gproperty-report'
    );
    url.searchParams.set('intent', intent);

    var recordId = gate.opaque(draft && draft.record_id);
    if (recordId) url.searchParams.set('record_id', recordId);
    else url.searchParams.delete('record_id');

    if (result && result.result_id) {
      url.searchParams.set('result_id', result.result_id);
    } else {
      url.searchParams.delete('result_id');
    }

    return url.pathname + url.search + url.hash;
  }

  function renderProvenance(root, gate, draft, result) {
    var box = root.querySelector('[data-report-preview-provenance]');
    if (!box) return;

    box.replaceChildren();

    var local = create('article', 'gproperty-report-preview__provenance-card');
    local.appendChild(create('strong', '', '本地 GProperty 草稿'));
    local.appendChild(create('span', '', '本地記錄 · ' + (gate.opaque(draft.record_id) || '—')));
    local.appendChild(
      create(
        'small',
        '',
        '最後更新 · ' + (gate.clean(draft.updated_at || draft.created_at) || '未記錄')
      )
    );
    box.appendChild(local);

    referenceCandidates(gate, draft).forEach(function (reference) {
      var card = create('article', 'gproperty-report-preview__provenance-card');
      card.appendChild(create('strong', '', '已保存分析參照'));
      card.appendChild(create('span', '', '分析參照 · ' + reference.result_id));
      card.appendChild(create('small', '', '最後更新 · ' + (reference.updated_at || '未記錄')));
      if (result.result_id === reference.result_id) {
        card.setAttribute('data-primary-reference', 'true');
      }
      box.appendChild(card);
    });
  }

  function render(root, gate, draft, result) {
    root.setAttribute('data-state', 'ready');
    setHidden(root, '[data-report-preview-empty]', true);
    setHidden(root, '[data-report-preview-content]', false);

    var verified = gate.isVerifiedDraft(draft);
    var estate = draft.estate_context || {};
    var location = gate.clean(draft.project_location || gate.locationLabel(estate));
    var asset = gate.clean(draft.asset_type);
    var need = gate.clean(draft.business_need);
    var stage = gate.clean(draft.project_stage);
    var files = Array.isArray(draft.evidence_files) ? draft.evidence_files.filter(Boolean) : [];

    setText(root, '[data-report-preview-record]', gate.opaque(draft.record_id) || '—');
    setText(root, '[data-report-preview-result]', result.result_id || '—');
    setText(root, '[data-report-preview-verification]', verified ? '地址已核實' : '未核實本機文字');
    setText(
      root,
      '[data-report-preview-state]',
      result.result_id ? '本機證據＋已保存分析參照' : '只顯示本機證據'
    );
    setText(
      root,
      '[data-report-preview-status-label]',
      result.result_id ? '已找到相符分析參照' : '只顯示本機證據；未生成正式結果'
    );

    var score = 0;
    var purposeText = [need, STAGE_LABELS[stage] || stage].filter(Boolean).join(' · ');

    score += mark(root, 'location', !!location, location || '尚未提供');
    score += mark(root, 'asset', !!asset, ASSET_LABELS[asset] || asset || '尚未提供');
    score += mark(root, 'purpose', !!need, purposeText || '尚未提供');
    score += mark(
      root,
      'files',
      files.length > 0,
      files
        .map(function (key) {
          return FILE_LABELS[key] || gate.clean(key);
        })
        .filter(Boolean)
        .join(' · ') || '尚未選擇'
    );

    setText(root, '[data-report-preview-count]', score + ' / 4');
    renderProvenance(root, gate, draft, result);

    var professional = root.querySelector('[data-report-preview-professional]');
    var history = root.querySelector('[data-report-preview-history]');

    if (professional) {
      professional.href = safeLink(
        gate,
        root.getAttribute('data-professional-url') || professional.getAttribute('href') || '',
        draft,
        result,
        'manual-verification'
      );
    }

    if (history) {
      history.href = safeLink(
        gate,
        root.getAttribute('data-history-url') || history.getAttribute('href') || '',
        draft,
        result,
        'evidence-preview'
      );
    }
  }

  function renderEmpty(root) {
    root.setAttribute('data-state', 'empty');
    setHidden(root, '[data-report-preview-empty]', false);
    setHidden(root, '[data-report-preview-content]', true);
    setText(root, '[data-report-preview-status-label]', '沒有相符本機資料；請先返回核實地址');
  }

  /** @param {HTMLElement} root */
  function init(root) {
    if (!root || root.getAttribute('data-runtime-version') === VERSION) return;
    root.setAttribute('data-runtime-version', VERSION);

    var gate = window.GPROPERTY_DATA_GATE;
    if (!gate) {
      renderEmpty(root);
      return;
    }

    var key = root.getAttribute('data-local-draft-key') || gate.canonicalDraftKey;
    var legacyKey = root.getAttribute('data-legacy-draft-key') || gate.legacyDraftKey;
    var stored = gate.readPropertyDraft(key, legacyKey);
    var draft = stored.draft;
    var query = new URLSearchParams(window.location.search || '');
    var queryRecord = gate.opaque(query.get('record_id'));
    var draftRecord = gate.opaque(draft && draft.record_id);

    if (queryRecord && (!draftRecord || queryRecord !== draftRecord)) {
      draft = null;
    }

    if (!draft || draft.source !== 'gproperty') {
      renderEmpty(root);
      return;
    }

    render(root, gate, draft, realResultReference(gate, draft, query));
  }

  function boot(scope) {
    var target = scope || document;
    if (target.matches && target.matches(ROOT)) init(target);
    all(target, ROOT).forEach(init);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target || document);
  });

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        boot(document);
      },
      { once: true }
    );
  } else {
    boot(document);
  }
})(window, document);
